import * as ActionTypes from "./actionTypes"
import {createAction} from 'redux-actions'
import rpcCall, {abortCall} from "../../../util/rpc/rpcCalls"
import {addCustomers, addProjects, addTasks, addTimeZoneGroups, addUser, addUserGroups, removeUser} from "../../../entities/actions"
import {getCopySelectedOption, getCopyUserId, getTab, getUserId} from "./selectors"
import {CopyWorkAssignmentOptions, HierarchyLevels} from "constants"
import actionsGenerator from '../hierarchyAssignmentsPanelTab/actionsGenerator'
import {setWorkAssignmentsCountersForUser} from '../workAssignmentsTab/actions'
import {closeAllPanels, handleCommonError, handleKeptMaAfterRemoveWaByToast, setViewerManagementAssignmentsCounters} from '../common/actions'
import {updateFeatures} from '../../../features/actions'
import {getLoggedInUserId} from '../../../loggedInUser/selectors'
import {getViewerManagementCounters} from '../common/selectors'
import {arrayToSet} from '../../../atUtils'
import {getUser} from '../../../entities/selectors'
import messageResource from '../../../messageResource'
import {rpcErrorHandler} from './utils'
import {isAborted} from '../../../util/rpc/rpcUtils'
import {Exceptions} from '../../../panels/user/editTeamAssignmentsPanel/constants'
import {Exceptions as CommonExceptions} from '../../../common/constants'
import * as SyncCallbacks from '../../../panels/user/editPanel/syncCallbacks'

const GET_VIEW_USER_WORK_ASSIGNMENTS_METHOD = 'UserManagementService.getViewUserWorkAssignments'

const hierarchyAssignmentsTabActions = actionsGenerator({
    actionTypes: ActionTypes
})

export const setUserHaveNoCptAtAll = createAction(ActionTypes.USER_HAVE_NO_CPT_AT_ALL_SET)

export const setTaskIds = hierarchyAssignmentsTabActions.setTaskIds

export const setProjectIds = hierarchyAssignmentsTabActions.setProjectIds

export const setCustomerIds = hierarchyAssignmentsTabActions.setCustomerIds

export const setUserId = hierarchyAssignmentsTabActions.setUserId

export const setTab = hierarchyAssignmentsTabActions.setTab

export const setManageTaskIds = hierarchyAssignmentsTabActions.setManageTaskIds

export const setManageProjectIds = hierarchyAssignmentsTabActions.setManageProjectIds

export const setManageExcludingSelfProjectIds = hierarchyAssignmentsTabActions.setManageExcludingSelfProjectIds

export const setManageCustomerIds = hierarchyAssignmentsTabActions.setManageCustomerIds

export const setManageExcludingSelfCustomerIds = hierarchyAssignmentsTabActions.setManageExcludingSelfCustomerIds

export const setUserCounters = hierarchyAssignmentsTabActions.setUserCounters

export const setTaskTabLoaded = hierarchyAssignmentsTabActions.setTaskTabLoaded

export const setProjectTabLoaded = hierarchyAssignmentsTabActions.setProjectTabLoaded

export const setCustomerTabLoaded = hierarchyAssignmentsTabActions.setCustomerTabLoaded

export const setSearchString = hierarchyAssignmentsTabActions.setSearchString

export const setSearchOpen = hierarchyAssignmentsTabActions.setSearchOpen

export const setLoaded = hierarchyAssignmentsTabActions.setLoaded

export const setLoading = hierarchyAssignmentsTabActions.setLoading

export const openPanel = hierarchyAssignmentsTabActions.openPanel

export const clearTabsLoaded = hierarchyAssignmentsTabActions.clearTabsLoaded

export const setIsShowArchiveEntities = hierarchyAssignmentsTabActions.setIsShowArchiveEntities

const resetSearch = hierarchyAssignmentsTabActions.resetSearch

export const changeWorkAssignmentPanelTab = (tab) => (dispatch, getState) => {
    const prevTab = getTab(getState())
    if (prevTab !== tab) {
        dispatch(resetSearch())
        dispatch(setTab(tab))
    }
}

export const openWorkAssignmentPanel = (id, tab) => (dispatch, getState) => {
    if (id === null)
        return

    const prevId = getUserId(getState())
    const prevTab = getTab(getState())
    if (id !== prevId) {
        dispatch(cancelLoadData())
        dispatch(openPanel({userId: id, tab: tab}))
        dispatch(closeCopyContentMenu())
        dispatch(closeAssignAllScopeContentMenu())
    } else if (tab !== prevTab) {
        dispatch(setTab(tab))
    } else {
        dispatch(closePanel())
    }
}

export const closePanel = () => dispatch => {
    abortCall(GET_VIEW_USER_WORK_ASSIGNMENTS_METHOD)
    dispatch(hierarchyAssignmentsTabActions.closePanel())
}

const cancelLoadData = () => dispatch => {
    abortCall(GET_VIEW_USER_WORK_ASSIGNMENTS_METHOD)
    dispatch(setLoaded(true))
    dispatch(setCustomerTabLoaded(true))
    dispatch(setProjectTabLoaded(true))
    dispatch(setTaskTabLoaded(true))
}

const prepareLoadedData = (data, tabType, userId) => (dispatch) => {
    dispatch(addCustomers(data.customers))
    dispatch(addProjects(data.projects))
    dispatch(addTasks(data.tasks))
    dispatch(setUserHaveNoCptAtAll(data.noCptAssignedToUserAtAll))

    dispatch(setUserCounters(data.userCounter))
    dispatch(setViewerManagementAssignmentsCounters(data.viewerCounter))
    dispatch(setWorkAssignmentsCountersForUser(userId, data.userCounter))

    const maCptIds = data.managementAssignmentsCptIds

    dispatch(setManageTaskIds(arrayToSet(maCptIds.taskIds)))
    dispatch(setManageProjectIds(arrayToSet(maCptIds.projectIds)))
    dispatch(setManageExcludingSelfProjectIds(arrayToSet(maCptIds.projectIdsExcludingSelf)))
    dispatch(setManageCustomerIds(arrayToSet(maCptIds.customerIds)))
    dispatch(setManageExcludingSelfCustomerIds(arrayToSet(maCptIds.customerIdsExcludingSelf)))

    switch (tabType) {
        case HierarchyLevels.TASK:
            dispatch(setTaskIds(data.taskIds))
            dispatch(setTaskTabLoaded(true))
            break
        case HierarchyLevels.PROJECT:
            dispatch(setProjectIds(data.projectIds))
            dispatch(setProjectTabLoaded(true))
            break
        case HierarchyLevels.CUSTOMER:
            dispatch(setCustomerIds(data.customerIds))
            dispatch(setCustomerTabLoaded(true))
            break
    }
    dispatch(setLoaded(true))
}

export const loadWorkAssignmentPanelDataAction = () => (dispatch, getState) => {
    const userId = getUserId(getState())
    const tabType = getTab(getState())
    dispatch(setLoading(true))
    rpcCall(GET_VIEW_USER_WORK_ASSIGNMENTS_METHOD, [userId, tabType], rpcErrorHandler)
        .then((data) => {
            dispatch(prepareLoadedData(data, tabType, userId))
            dispatch(setLoading(false))
        })
        .catch((err) => {
            if (isAborted(err)) return
            dispatch(commonWAPanelErrorHandler(err))

            dispatch(setLoading(false))
        })
}

export const revokeAllTypeAction = () => (dispatch, getState) => {
    const userId = getUserId(getState())
    const type = getTab(getState())
    dispatch(setLoading(true))
    rpcCall('UserManagementService.revokeAllWorkAssignment', [userId, type], rpcErrorHandler)
        .then((data) => {
            dispatch(prepareLoadedData(data, type, userId))
            dispatch(setLoading(false))
            dispatch(handleKeptMaAfterRemoveWaByToast({cptWaChangesFlags: data.cptWaChangesFlags, level: type, all: true}))
            dispatch(updateUserHasAssignedWorkScope(userId, !data.noCptAssignedToUserAtAll))
        })
        .catch((err) => {
            dispatch(setLoading(false))
            dispatch(commonWAPanelErrorHandler(err))
        })
}

export const revokeEntitiesAction = (revokeEntityLevel, id) => (dispatch, getState) => {
    const userId = getUserId(getState())
    const typeTab = getTab(getState())
    dispatch(setLoading(true))
    rpcCall('UserManagementService.revokeEntityWorkAssignment', [userId, typeTab, id, revokeEntityLevel], rpcErrorHandler)
        .then((data) => {
            dispatch(prepareLoadedData(data, typeTab, userId))
            dispatch(setLoading(false))
            dispatch(handleKeptMaAfterRemoveWaByToast({cptWaChangesFlags: data.cptWaChangesFlags, level: revokeEntityLevel, all: false}))
            dispatch(updateUserHasAssignedWorkScope(userId, !data.noCptAssignedToUserAtAll))
        })
        .catch((err) => {
            dispatch(setLoading(false))
            dispatch(commonWAPanelErrorHandler(err))
        })
}

const updateUserHasAssignedWorkScope = (userId, hasAssignedWorkScope) => (dispatch, getState) => {
    const user = getUser(getState(), userId)
    dispatch(addUser({
        ...user,
        hasAssignedWorkScope,
    }))
}

export const openCopyContentMenu = createAction(ActionTypes.COPY_CONTENT_OPEN)

export const closeCopyContentMenu = createAction(ActionTypes.COPY_CONTENT_CLOSE)

export const setShowCopy = createAction(ActionTypes.SHOW_COPY_SET)

export const setCopyUserId = createAction(ActionTypes.COPY_USER_ID_SET)

export const setViewerHasEntireScope = createAction(ActionTypes.COPY_VIEWER_HAS_ENTIRE_SCOPE_SET)

export const setCopyLoading = createAction(ActionTypes.COPY_LOADING_SET)

export const setCopyAllScope = createAction(ActionTypes.COPY_ALL_SCOPE_SET)

export const setCopyCounters = createAction(ActionTypes.COPY_COUNTERS_SET)

export const setCopyOption = createAction(ActionTypes.COPY_OPTION_SET)

export const setCopySelectorUsers = createAction(ActionTypes.COPY_USER_IDS_FOR_SELECTOR_SET)

export const openCopyMenu = () => (dispatch) => {
    dispatch(openCopyContentMenu())
    dispatch(loadUsers())
}

export const loadUserCounters = (userId) => (dispatch, getState) => {
    dispatch(setCopyLoading(true))
    rpcCall('UserManagementService.getUserWorkAssignmentsCounters', [userId], rpcErrorHandler)
        .then((data) => {
            dispatch(setCopyAllScope(data.canManageAllScope && data.canUserManageAllScope))

            let copyCounters = data.cptCounters
            if (!data.canManageAllScope && data.canUserManageAllScope) {
                copyCounters = getViewerManagementCounters(getState())
            }
            dispatch(setCopyCounters(copyCounters))

            dispatch(setCopyUserId(userId))
            dispatch(setCopyOption(null))
            dispatch(setCopyLoading(false))

            dispatch(setViewerHasEntireScope(data.viewerHasEntireScope))
        })
        .catch((err) => {
            dispatch(setCopyLoading(false))
            dispatch(commonWAPanelErrorHandler(err))
            dispatch(closeCopyContentMenu())
        })

}

export const loadUsers = () => (dispatch) => {
    rpcCall('UserManagementService.getUserSelectorData', [])
        .then((data) => {
            dispatch(updateFeatures(
                {
                    UGR: data.ugrEnabled,
                    TZG: data.tzgEnabled,
                }
            ))
            dispatch(addTimeZoneGroups(data.timeZoneGroups))
            dispatch(addUserGroups(data.userGroups))
            dispatch(setCopySelectorUsers(data.users))
        })
        .catch((err) => {
            // TODO add error handling
            console.log(err)
        })
}

export const copyAssignments = () => (dispatch, getState) => {
    const userTo = getUserId(getState())
    const userFrom = getCopyUserId(getState())
    const option = getCopySelectedOption(getState())

    rpcCall('UserManagementService.copyWorkAssignmentsFrom', [userTo, userFrom, option], rpcErrorHandler)
        .then((data) => {
            dispatch(closeCopyContentMenu())
            dispatch(setTaskTabLoaded(false))
            dispatch(setProjectTabLoaded(false))
            dispatch(setCustomerTabLoaded(false))
            dispatch(addUser(data.userInfo))
        })
        .catch((error) => {
            switch (error.getException()) {
                case Exceptions.NoSuchUserException:
                    dispatch(closeAllPanels())
                    break
                case Exceptions.NoSuchCopyUserException:
                    alert(messageResource.getMessage('work_assignments.panel.copy.error.user_deleted'))
                    dispatch(removeUser(userFrom.id))
                    SyncCallbacks.onNoSuchUserException(userFrom.id)
                    break
                case Exceptions.UserHasAccessToAllScopeException:
                    alert(messageResource.getMessage('work_assignment.error.copy.userTo_has_entire_scope'))
                    window.location.reload()
                    break
                case CommonExceptions.NO_RIGHTS_TO_SUBMIT_TT_EXCEPTION:
                    alert(messageResource.getMessage('work_assignment.error.copy.userTo_hast_submitTT'))
                    window.location.reload()
                    break
                default:
                    dispatch(commonWAPanelErrorHandler(error))
                    console.error(error)
                    dispatch(closeCopyContentMenu())
            }
        })
}

export const openAssignAllScopeContentMenu = createAction(ActionTypes.ASSIGN_ALL_SCOPE_CONTENT_OPEN)

export const closeAssignAllScopeContentMenu = createAction(ActionTypes.ASSIGN_ALL_SCOPE_CONTENT_CLOSE)

export const assignAllWorkAssignments = () => (dispatch, getState) => {
    const userTo = getUserId(getState())

    rpcCall('UserManagementService.assignAllWorkAssignmentsFromMyScope', [userTo], rpcErrorHandler)
        .then((data) => {
            dispatch(closeAssignAllScopeContentMenu())
            dispatch(setTaskTabLoaded(false))
            dispatch(setProjectTabLoaded(false))
            dispatch(setCustomerTabLoaded(false))
            dispatch(addUser(data.userInfo))
        })
        .catch((err) => {
            switch (err.getException()) {
                case Exceptions.UserHasAccessToAllScopeException:
                    alert(messageResource.getMessage('work_assignment.error.copy.userTo_has_entire_scope'))
                    window.location.reload()
                    break
                case CommonExceptions.NO_RIGHTS_TO_SUBMIT_TT_EXCEPTION:
                    alert(messageResource.getMessage('work_assignment.error.copy.userTo_hast_submitTT'))
                    window.location.reload()
                    break
                default:
                    dispatch(commonWAPanelErrorHandler(err))
                    console.error(err)
                    dispatch(closeCopyContentMenu())
            }

            return true
        })
}

const commonWAPanelErrorHandler = (error) => (dispatch) => {
    dispatch(handleCommonError(error))

    switch (error.getException()) {
        case Exceptions.WORK_ASSIGNMENTS_FEATURE_DISABLED_EXCEPTION:
            alert(messageResource.getMessage("common.turned_off_functionality", [messageResource.getMessage("features.WAS.title")]))
            window.location.reload()
            break
        case Exceptions.UserHasAccessToAllScopeException:
            alert(messageResource.getMessage('work_assignments.error.selected_user_have_entire_scope'))
            window.location.reload()
            break
        case CommonExceptions.NO_RIGHTS_TO_SUBMIT_TT_EXCEPTION:
            alert(messageResource.getMessage('work_assignments.error.selected_user_does_not_have_submit_tt'))
            window.location.reload()
            break
    }
}





// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentPanel/actions.js